<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon @click="openCreate()" title="Crear Usuario">
          <v-icon color="primary">fa fa-plus</v-icon>
        </v-btn>
        <v-btn icon disabled>
          <v-icon>more_vert</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-divider style="margin:0px"></v-divider>
      <v-card>
        <v-card-text class="pt-0">
          <v-flex class="row pt-4">
            <v-layout>
              <v-flex text-lg-left>
                <v-btn class="ml-0" flat icon color="primary" v-on:click="refresh">
                  <v-icon>cached</v-icon>
                </v-btn>
              </v-flex>
              <v-flex text-lg-right>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table :pagination.sync="pagination" :items="users" :headers="headers" class="v-table-list theme--light" :search="search">
              <template slot="items" scope="props">
                <tr v-if="props.item.profile.uid!='5c2cf2346c698346ce20c1fc' && props.item.profile!=null" :active="props.selected" @click="props.selected = !props.selected">
                  <td
                    class="text-xs-left cut-text"
                  >{{props.item.profile.user_id}}</td>
                  <!--  =='ASISTENCIA CIA. LTDA.' ? 'ssdw':'dd' -->
                  <td
                    class="text-xs-left cut-text"
                  >{{props.item.profile.fullName}}</td>
<!--                   <td
                    v-if=" props.item.profile!=null && (typeof props.item.profile.business_name!='undefined' && props.item.profile.business_name!='')"
                    class="text-xs-left cut-text"
                  >{{ props.item.profile.business_name}}</td>
                  <td
                    v-if=" props.item.profile!=null && typeof props.item.profile.business_name=='undefined'"
                    class="text-xs-left cut-text"
                  >{{props.item.profile.first_name }} {{props.item.profile.first_surname }} {{props.item.profile.second_surname }}</td> -->
                  <td
                    class="text-xs-left cut-text"
                  >{{ props.item.profile.email}}</td>
                  <td
                    class="text-xs-left cut-text"
                  >{{ setUserType(props.item.scope) }}</td>
                   <td
                    class="text-xs-left cut-text"
                  >{{ 
                    moment(
                props.item.profile.createdAt,
                "YYYY-MM-DD"
              ).format("YYYY-MM-DD") }}</td>
                </tr>

              </template>
              <template slot="no-data">
                <div>{{$t('message.noRecords')}}</div>
              </template>
              <template
                slot="pageText"
                slot-scope="props"
              >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-card>
    <UserCreate v-if="showCreateDialog" ref="CreateDialog"></UserCreate>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import UserCreate from "./UserCreate";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import { EventBus } from "@/imports/EventBus";
import moment, { locale } from "moment";

export default {
  computed: {
    ...mapGetters(["users", "loadingUsers"])
  },
  components: {
    UserCreate
  },
  beforeDestroy() {
    EventBus.$off("openForm");
  },
  mounted() {
    this.$store.dispatch("getUsers");
  },
  methods: {
    nzDate: nzDate,
    openCreate() {
      this.showCreateDialog = true;

      setTimeout(() => {
        this.$refs.CreateDialog.open();
        this.$refs.CreateDialog.errors.clear();
        EventBus.$emit("openForm");
      }, 10);
    },
    updateValue() {
      this.$store.dispatch("getUsers");
    },
    refresh() {
      this.$store.dispatch("getUsers");
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    setUserType(scope){
      if(scope.includes("aps_admin")) return "Admin";

      if(scope.includes("aps_executive")) return "Ejecutivo APS";

      if(scope.includes("aps_promotor")) return "Promotor APS";

      return "APS";
 
    }
  },
  watch: {
    loadingUsers(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando usuarios");
      } else {
        this.$root.$emit("hideLoading");
      }
    }
  },
  data() {
    return {
      search: "",
      showCreateDialog: false,
      pagination: {
         descending: true,
  page: 1,
  rowsPerPage: 5 ,
        sortBy: "profile.createdAt"
      },
      searchValue: "",
      headers: [
        {
          align: "left",
          sortable: false,
          text: "Usuario ID",
          value: "profile.user_id"
        },
        {
          align: "left",
          sortable: false,
          text: "Nombre/Razón Social",
          value: "profile.fullName"
        },
        {
          align: "left",
          sortable: false,
          text: "Email",
          value: "profile.email"
        },
        {
          align: "left",
          sortable: true,
          text: "Tipo",
          value: "profile.type"
        },
        {
          align: "left",
          sortable: true,
          text: "Fecha de creación",
          value: "profile.createdAt"
        }
      ]
    };
  }
};
</script>